import { Link } from "react-router-dom";
import { FiBell } from "react-icons/fi";
import useMerchantNotifications from "../../hooks/useMerchantNotifications";
import PageHeader from "../../components/PageHeader";
import EmptyState from "../../components/EmptyState";
import StatusBadge from "../../components/StatusBadge";

const TYPE_LABEL = {
  order: "Order",
  product: "Product",
  message: "Update",
};

const MerchantNotificationsPage = () => {
  const { data: notifications = [], isLoading, isError } = useMerchantNotifications();

  return (
    <>
      <PageHeader title="Notifications" subtitle="Orders, product reviews, and marketplace updates" icon={FiBell} />
      {isError && <p style={{ color: "var(--dash-danger)" }}>Failed to load notifications.</p>}
      {isLoading && <p>Loading…</p>}
      {!isLoading && notifications.length === 0 && !isError && (
        <EmptyState icon={FiBell} title="No notifications" message="Order and product updates will appear here." />
      )}
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {notifications.map((n) => (
          <div key={n.id} className="dashboard-card" style={{ margin: 0 }}>
            <div style={{ display: "flex", justifyContent: "space-between", gap: 12, alignItems: "flex-start" }}>
              <strong>{n.title}</strong>
              <StatusBadge status={TYPE_LABEL[n.type] || n.type} variant={n.type === "product" ? "danger" : "default"} />
            </div>
            <p style={{ margin: "8px 0 0", color: "var(--dash-muted)", fontSize: 14 }}>{n.message}</p>
            <p style={{ margin: "8px 0 0", fontSize: 12, color: "var(--dash-muted)" }}>
              {new Date(n.createdAt).toLocaleString()}
            </p>
            {n.link && (
              <Link to={n.link} className="dashboard-btn dashboard-btn--secondary" style={{ marginTop: 12 }}>
                {n.type === "product" ? "Fix product" : n.type === "order" ? "View order" : "Open"}
              </Link>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default MerchantNotificationsPage;
